<div class="mb-2">
  <h1 class="main-title">Mis novedades</h1>
</div>

<mat-tab-group animationDuration="0ms">
  <mat-tab label="Seguridad / Calidad / Medio ambiente">
    <button class="button button-success button-sm" (click)="newUpdateRecord('seguridad')">
      Nueva novedad
    </button>
    <app-table
      class="table-news table-switch"
      [columns]="tableColumnsSeguridad"
      [data]="flattenedData['seguridad']"
      [tableType]="'seguridad'"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
      (selectAllChange)="onSelectAllChange($event)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)" title="Ver">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
          <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <button (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </mat-tab>
<!--
  <mat-tab label="Condiciones de operación">
    <form
      *ngIf="formGroups['operacion'] && groupedData['operacion']"
      [formGroup]="formGroups['operacion']"
      (ngSubmit)="submitTabData('operacion')"
    >
      <div *ngFor="let group of groupedData['operacion']" class="grouped-container mb-3">
        <div class="grid grid-cols-4 gap-4">
          <div *ngFor="let element of group.elements">
            <label *ngIf="element.element.name != 'Label'">{{ element.label }}</label>
            <ng-container [ngSwitch]="element.element.name">
              <input
                *ngSwitchCase="'TextBox'"
                class="input input-sm"
                type="text"
                [formControlName]="element.id.toString()"
                placeholder="{{ element.label }}"
              />
  
              <textarea
                *ngSwitchCase="'TextArea'"
                class="textarea"
                [formControlName]="element.id.toString()"
                placeholder="{{ element.label }}"
              ></textarea>
  
              <input *ngSwitchCase="'Date'" class="input input-sm" type="date" [formControlName]="element.id.toString()" />
  
              <input *ngSwitchCase="'Time'" class="input input-sm" type="time" [formControlName]="element.id.toString()" />
  
              <select *ngSwitchCase="'ComboBox'" [formControlName]="element.id.toString()">
                <option *ngFor="let option of element.options" [value]="option.value">
                  {{ option.value }}
                </option>
              </select>
  
              <mat-checkbox *ngSwitchCase="'CheckBox'" [formControlName]="element.id.toString()">
                {{ element.label }}
              </mat-checkbox>
  
              <span *ngSwitchCase="'Label'">{{ element.label }}</span>
            </ng-container>
            <div
              class="error-message"
              *ngIf="formGroups['operacion'].get(element.id.toString())?.errors?.['serverError']"
            >
              {{ formGroups['operacion'].get(element.id.toString())?.errors?.['serverError'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button type="submit" class="button button-success">Guardar</button>
      </div>
    </form>
  </mat-tab>
-->

  <mat-tab label="Personal">
    <button class="button button-warning button-sm" (click)="newUpdateRecord('personal')">
      Nueva novedad
    </button>
    <app-table
      class="table-news table-switch"
      [columns]="tableColumns"
      [data]="flattenedData['personal']"
      [tableType]="'personal'"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
      (selectAllChange)="onSelectAllChange($event)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
          <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <button (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </mat-tab>
<!--
  <mat-tab label="Despacho">
    <form
      *ngIf="formGroups['despacho'] && groupedData['despacho']"
      [formGroup]="formGroups['despacho']"
      (ngSubmit)="submitTabData('despacho')"
    >
      <div *ngFor="let group of groupedData['despacho']" class="grouped-container">
        <div class="grid grid-cols-5 gap-4">
          <div *ngFor="let element of group.elements" [ngClass]="element.element.name === 'Label' ? 'subtitle col-span-5' : 'field'">
            <label *ngIf="element.element.name != 'Label'">{{ element.label }}</label>
            <ng-container [ngSwitch]="element.element.name">
              <input
                *ngSwitchCase="'TextBox'"
                type="text"
                class="input input-sm"
                [formControlName]="element.id.toString()"
                placeholder="{{ element.label }}"
              />

              <textarea
                *ngSwitchCase="'TextArea'"
                [formControlName]="element.id.toString()"
                placeholder="{{ element.label }}"
              ></textarea>
              
              <input *ngSwitchCase="'Date'" class="input input-sm" type="date" [formControlName]="element.id.toString()" />
              <input *ngSwitchCase="'Time'" class="input input-sm" type="time" [formControlName]="element.id.toString()" />
              <select *ngSwitchCase="'ComboBox'" [formControlName]="element.id.toString()">
                <option *ngFor="let option of element.options" [value]="option.value">
                  {{ option.value }}
                </option>
              </select>
              <mat-checkbox *ngSwitchCase="'CheckBox'" [formControlName]="element.id.toString()">
                {{ element.label }}
              </mat-checkbox>
              <h3 class="mb-0" *ngSwitchCase="'Label'">{{ element.label }}</h3>
            </ng-container>
            <div
              class="error-message"
              *ngIf="formGroups['despacho'].get(element.id.toString())?.errors?.['serverError']"
            >
              {{ formGroups['despacho'].get(element.id.toString())?.errors?.['serverError'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button type="submit" class="button button-success">Guardar</button>
      </div>
    </form>
  </mat-tab>
  -->
</mat-tab-group>
